import { Component, OnInit } from '@angular/core';
import { IStepValidation, WizardStep } from '../../WizardStep';
import { DataSourceParams, ITableColumn } from '../../../../store/models/table.model';
import { StaticDataSource } from '../../../../datasources/static.datasource';
import { WizardService } from '../../wizard.service';
import { SelectionChange } from '@angular/cdk/collections';

export interface IContactStatus {
  status: string;
}

@Component({
  selector: 'app-contact-status-selection-step',
  templateUrl: './contact-status-selection-step.component.html',
  styleUrls: ['./contact-status-selection-step.component.scss'],
})
export class ContactStatusSelectionStepComponent implements OnInit, WizardStep {
  static STEP_NAME = 'select-status';

  wizardData: any;

  tableColumns: ITableColumn<IContactStatus>[] = [
    {
      id: 'status',
      title: 'Status',
    },
  ];

  dataSource: StaticDataSource<IContactStatus>;
  dataSourceParams: DataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'status',
    sortDir: 'asc',
    filters: {},
  };
  preselected: IContactStatus[] = [];
  private selectedStatuses: string[];

  constructor(private readonly wizardService: WizardService) {
  }

  ngOnInit() {
    this.wizardService.disableNextButton();
    this.dataSource = new StaticDataSource<IContactStatus>([
      {
        status: 'Active',
      },
      {
        status: 'Meeting',
      },
      {
        status: 'Follow Up',
      },
      {
        status: 'Inactive',
      },
      {
        status: 'Cycle',
      },
    ]);

    this.preselected = [{
      status: 'Active',
    },
      {
        status: 'Meeting',
      },
      {
        status: 'Follow Up',
      },
      {
        status: 'Inactive',
      },
      {
        status: 'Cycle',
      }];

    if (
      this.wizardData[ContactStatusSelectionStepComponent.STEP_NAME] &&
      Object.keys(
        this.wizardData[ContactStatusSelectionStepComponent.STEP_NAME],
      ).length > 0
    ) {
      this.preselected = this.wizardData[
        ContactStatusSelectionStepComponent.STEP_NAME
        ].map(i => ({ status: i }));
    }
  }

  provideData(): any {
    return this.selectedStatuses;
  }

  async validate(): Promise<IStepValidation> {
    let success = false;
    const errors = [];

    if (this.selectedStatuses && this.selectedStatuses.length > 0) {
      success = true;
    } else {
      errors.push('Please, select at least 1 status');
    }

    return {
      success,
      errors,
    };
  }

  onSelection($event: SelectionChange<{ status }>) {
    this.wizardService.setNextButtonState($event.source.selected.length > 0);
    this.selectedStatuses = $event.source.selected.map(e => e.status);
  }
}
